export const CONNECTION_GAMES = [
  [
    {
      category: "Dislikes",
      words: ["Orange", "Bok Choy", "Period", "MUN"],
      difficulty: 1,
      imageSrc:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTct4QnA6zwU4tyn9vq_ADJ8Ey6RfIWK-6V6g&s",
    },
    {
      category: "Nuggets",
      words: ["Chicken", "Gold", "Dinosaur", "Wisdom"],
      difficulty: 2,
      imageSrc:
        "https://cdn.bfldr.com/U447IH35/as/j5rk2ntjhx2z63wkn7gwkjtz/1560758__1psd?auto=webp&format=jpg",
    },
    {
      category: "Songs from the Heartstopper Soundtrack",
      words: ["Serotonin", "Rush", "mona lisa", "Car Park"],
      difficulty: 3,
      imageSrc:
        "https://i.scdn.co/image/ab67706f00000002f47a554389826fa3df0c1217",
    },

    {
      category: "Things to Wave At",
      words: ["68", "Friend", "Taxi", "Ship"],
      difficulty: 4,
      imageSrc:
        "https://barp.ca/bus/bctransit/vancouver/shuttle/cmbc19538-1.jpg",
    },
  ],
];
